module.exports = __webpack_public_path__ + "./fonts/icomoon.33cc43.ttf";